import { useContext } from 'react';
import { Menu, Text } from '@mantine/core';

import {
  AS_ADDITION,
  AS_INSTRUCTION,
  REPLACES_MAIN,
  IGNORE,
  DEFAULT,
  MAPPING_STATUS,
} from 'constants/mapping';
import { MenuMappingContext } from 'components/MenuManagement/MenuEdit/MenuMapping/MenuMapping';

import {
  setAppMenuWithChecked,
  setEditedItemsWithChecked,
  setSelectedValue,
} from 'helpers/mappingColumns';

import { CAMEL_TYPES } from 'constants/menuManagement';

interface ActionButtonsProps {
  isModifierSelected?: boolean;
  rowKey: string;
}

export default function ActionMenu({ isModifierSelected, rowKey }: ActionButtonsProps) {
  const itemType = isModifierSelected ? CAMEL_TYPES.modifiers : CAMEL_TYPES.items;

  const { appMenu, setAppMenu, editedItems, setEditedItems, checkedItems } =
    useContext(MenuMappingContext);

  const setRowStatus = (rKey: string, flag: string) => {
    const defaultProps = {
      [AS_INSTRUCTION]: false,
      [AS_ADDITION]: false,
      [REPLACES_MAIN]: false,
      [IGNORE]: false,
    };

    const modifierActionProps = {
      [DEFAULT]: {
        ...defaultProps,
        editedItems: { ...defaultProps },
        appMenu: { ...defaultProps },
      },
      [AS_ADDITION]: {
        ...defaultProps,
        editedItems: { ...defaultProps, [AS_ADDITION]: true },
        appMenu: { ...defaultProps, [AS_ADDITION]: true },
      },
      [AS_INSTRUCTION]: {
        ...defaultProps,
        editedItems: { ...defaultProps, [AS_INSTRUCTION]: true },
        appMenu: { ...defaultProps, [AS_INSTRUCTION]: true },
      },
      [REPLACES_MAIN]: {
        ...defaultProps,
        editedItems: { ...defaultProps, [REPLACES_MAIN]: true },
        appMenu: { ...defaultProps, [REPLACES_MAIN]: true },
      },
      [IGNORE]: {
        ...defaultProps,
        editedItems: { ...defaultProps, [IGNORE]: true },
        appMenu: { ...defaultProps, [IGNORE]: true },
      },
    };

    // @ts-expect-error helper not typed
    const selectedSettings = modifierActionProps[flag];

    setEditedItemsWithChecked({
      key: rKey,
      updatedData: {
        ...selectedSettings.editedItems,
      },
      checkedItems,
      editedItems,
      setEditedItems,
    });

    setAppMenuWithChecked({
      key: rKey,
      itemType,
      updatedData: {
        uuidExternalId: null,
        externalIdMapping: null,
        mappingStatus: MAPPING_STATUS.STAGED_UNMAPPED,
        ...selectedSettings.appMenu,
      },
      checkedItems,
      setAppMenu,
      appMenu,
    });
  };

  const editMenuItems = isModifierSelected
    ? [
        {
          label: 'Map as Standard Modifier',
          value: DEFAULT,
        },
        { label: 'Add as Additional Item', value: AS_ADDITION },
        { label: 'Add as Instruction (No ID)', value: AS_INSTRUCTION },
        { label: 'Replace an Item', value: REPLACES_MAIN },
        { label: 'Ignore Modifier (No ID)', value: IGNORE },
      ]
    : [
        {
          label: 'Map as Standard Item',
          value: DEFAULT,
        },
        { label: 'Add as Instruction (No ID)', value: AS_INSTRUCTION },
        { label: 'Ignore Item (No ID)', value: IGNORE },
      ];

  return (
    <Menu.Dropdown>
      {editMenuItems.map(item => (
        <Menu.Item key={`${item.value}_item`} onClick={() => setRowStatus(rowKey, item.value)}>
          <Text variant="label-md">{item.label}</Text>
        </Menu.Item>
      ))}
      <Menu.Item
        key="unmap_item"
        onClick={() => {
          setSelectedValue({
            rowKey,
            value: null,
            itemType,
            editedItems,
            setEditedItems,
            checkedItems,
            setAppMenu,
            appMenu,
          });
          setRowStatus(rowKey, DEFAULT);
        }}
      >
        <Text variant="label-md">Unmap Modifier</Text>
      </Menu.Item>
    </Menu.Dropdown>
  );
}
